import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const GrenadaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14858'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14858)'>
				<rect
					width='20'
					height='14'
					fill='#E42235'
				/>
				<rect
					x='1.9043'
					y='1.8667'
					width='16.1905'
					height='10.2667'
					fill='#079B77'
				/>
				<mask
					id='mask1_2332_14858'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='1'
					y='1'
					width='18'
					height='12'>
					<rect
						x='1.9043'
						y='1.8667'
						width='16.1905'
						height='10.2667'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_14858)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M3.1369 7.09226C3.40654 7.51515 3.79367 7.7943 4.15424 7.86594C4.35275 7.90538 3.9893 7.01321 4.14768 6.91622C4.28282 6.83347 4.933 7.57539 4.98994 7.4206C5.12093 7.06446 5.04366 6.56014 4.75223 6.10308C4.33413 5.44737 4.31781 5.88015 3.18753 5.4104C3.30571 6.08218 2.7188 6.43655 3.1369 7.09226Z'
						fill='#FFD938'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M9.99953 7.00003L18.0948 1.8667H1.9043L9.99953 7.00003ZM9.99953 7.00003L1.9043 12.1334H18.0948L9.99953 7.00003Z'
						fill='#FFD93B'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M10.0001 9.33341C11.3151 9.33341 12.381 8.28875 12.381 7.00008C12.381 5.71142 11.3151 4.66675 10.0001 4.66675C8.68513 4.66675 7.61914 5.71142 7.61914 7.00008C7.61914 8.28875 8.68513 9.33341 10.0001 9.33341Z'
						fill='url(#paint0_linear_2332_14858)'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M10.0005 7.71997L8.88087 8.51025L9.30185 7.22254L8.18893 6.42326L9.5687 6.4177L10.0005 5.13342L10.4322 6.4177L11.812 6.42326L10.6991 7.22254L11.1201 8.51025L10.0005 7.71997Z'
						fill='#FFD938'
					/>
				</g>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_14858'
					x1='7.61914'
					y1='4.66675'
					x2='7.61914'
					y2='9.33341'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#E21C30' />
					<stop
						offset='1'
						stopColor='#CE1225'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default GrenadaFlagIcon;
